<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="odontograma">
    <div class="">
      <div :id="'TITULO_ODON_'+odontograma.coodId" class="text-blue-600 col-span-12 font-bold border-b">{{ odontograma.coodNombre }}</div>
      <template v-if="!isView">
        <h4  class="col-12 mt-5">Acciones:</h4>
        <div class="inline-flex gap-2">
          <div class="inline-flex rounded-lg shadow-sm sticky top-0 bg-white dark:bg-neutral-900 z-10">
            <button
              type="button"
              class="py-2 px-2 inline-flex justify-center items-center gap-2 -ms-px first:rounded-s-lg first:ms-0 last:rounded-e-lg text-sm font-medium focus:z-10 border border-gray-400 text-gray-800 shadow-sm disabled:opacity-50 disabled:pointer-events-none dark:border-neutral-700 dark:text-white"
              :class="isBorrar ? 'bg-gray-200 dark:bg-neutral-700 text-gray-900' : 'bg-white dark:bg-neutral-900'"
              @click="isBorrar = !isBorrar">
              <TrashIcon class="nohover shrink-0 size-4"></TrashIcon>
            </button>
            <ButtonDefault :is-loading="guardando" :disabled="isLoadingBtnSanos" @click="guardar">
              Guardar
            </ButtonDefault>
            <span
            class=" py-2 px-2 inline-flex justify-center items-center gap-2 -ms-px first:rounded-s-lg first:ms-0 last:rounded-e-lg text-sm font-medium focus:z-10 border bg-slate-200 border-gray-400 text-gray-800 shadow-sm disabled:opacity-50 disabled:pointer-events-none dark:border-neutral-700 dark:text-white"
            >
              {{ Object.keys(marcacionSeleccionada).length ? marcacionSeleccionada.nombre : 'Seleccione una convencion'}}
              <div
              v-if="Object.keys(marcacionSeleccionada).length"
              class="h-6 w-10"
              v-html="marcacionSeleccionada.svg"
              ></div>
              <div
              v-if="Object.keys(marcacionSeleccionada).length && !marcacionSeleccionada.svg"
              class=" h-6 w-10"
              :style="'background-color:'+marcacionSeleccionada.color"
              ></div>
            </span>
          </div>
          <div class="flex gap-2">
            <template v-if="odontograma.coodNombre == 'Odontograma'">
              <ButtonDefault :is-loading="isLoadingBtnSanos" @click="setDientosSanosByTipo('AUSENTE')"><MdiIcon icono="mdiBlockHelper" /></ButtonDefault>
              <ButtonDefault :is-loading="isLoadingBtnSanos" @click="setDientosSanosByTipo('ADULTO')"><MdiIcon icono="mdiCheck" /><MdiIcon icono="mdiHumanMale" /></ButtonDefault>
              <ButtonDefault :is-loading="isLoadingBtnSanos" @click="setDientosSanosByTipo('MENOR')"><MdiIcon icono="mdiCheck" /><MdiIcon icono="mdiHumanChild" /></ButtonDefault>
            </template>
            <ButtonDefault @click="historico = !historico">Historico</ButtonDefault>
          </div>
        </div>
      </template>
    </div>
    <div v-if="historico" class="my-2">
      <OdontogramaTratamiento 
        :odontograma="odontograma"
        :citt-id="cittId"
      />
    </div>
    <div class="marcaciones my-2">
        <div class="grid grid-cols-6 gap-2">
          <template v-for="marcacion in marcacionesVisibles" :key="marcacion.id">
            <div
              :id="marcacion.identificador"
              class="marcacion cursor-pointer hover:bg-blue-200"
              :title="marcacion.nombre"
              @click="alterMarcacion(marcacion, $event)">
              
              <div class="flex items-center p-2">
                <div v-if="!marcacion.svg" class="mx-3 my-2 h-4 w-4" :style="'background-color:'+marcacion.color"></div>
                <div v-else class="h-8 w-10" v-html="marcacion.svg"></div>
                <div class="text-center text-[10px] text-gray-600 overflow-hidden truncate">
                  {{ marcacion.nombre }}
                </div>
              </div>
            </div>
          </template>
        </div>
    </div>
    <OdontogramaCanvas 
        v-if="xml"
        :is-view="isView"
        :odontograma="odontograma"
        :ciad-id="ciadId"
        :citt-id="cittId"
        :comp="comp"
        :dibujar-en-el-d-o-m="dibujarEnElDOM"
        :xml="xml"
        />
  </div>
</template>
<script setup lang="ts">
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { TrashIcon } from '@heroicons/vue/24/outline'
import type { ICitaOdontologicas }  from '@/modules/Asistencial/interfaces'
import type {  IConfOdontogramas, IConfOdontogramasConvenciones } from '@/modules/Configuracion/interfaces'
import { odontologicaService } from '@/services'
import type { IFormComponent } from '@/modules/Administracion/interfaces'
import { useOdontograma } from '@/modules/Asistencial/composables/useOdontograma'
import { closeModal } from '@/modules/Core/usings/generales'
import OdontogramaCanvas from './OdontogramaCanvas.vue'
import OdontogramaTratamiento from './OdontogramaTratamiento.vue'

const guardando = ref(false)
const props = defineProps<{
  ciadId: number,
  cittId: number,
  odontograma: IConfOdontogramas,
  setDatosOdontologia: ReturnType<typeof useOdontograma>['setDatosOdontologia'],
  isView?: boolean
  comp?: IFormComponent
}>()
const historico = ref(false)
const xml = ref<string | null>(null)
const { odontograma, cittId, isView = false } = props
const { setMarcacionSeleccionada, marcacionSeleccionada, isBorrar, marcaciones, getStore, getAusentesAtencion, getDientesPresentesAtencion, setIsBorrar, setDientesSanos, setDientesAusentes, generarSVG, dibujarEnElDOM } = useOdontograma( props.comp? 'historia':'view')
const isLoadingBtnSanos = ref(false)
const marcacionesVisibles = computed(() => {
  if(odontograma.coodNombre == 'Control placa') {
    return marcaciones.value.filter(m => m.identificador != 'DIENTE_AUSENTE')
  }
  return marcaciones.value
})
const alterMarcacion = (marcacion: IConfOdontogramasConvenciones, event: Event) => {
  const elem = event.target as HTMLElement
  const contenedor = elem?.closest(".marcacion")
  setIsBorrar(false)
  if (marcacionSeleccionada.value) {
    const restante = document.querySelectorAll(`.marcacion:not(#${contenedor?.getAttribute("id")})`)
    restante.forEach(element => {
      const svgElements = element.getElementsByTagName('svg');
      if (svgElements && svgElements.length > 0) {
        svgElements[0].classList.remove("marcacionSeleccionada");
      }
    })
  }
  setMarcacionSeleccionada(marcacionSeleccionada.value.id == marcacion.id ? {} as IConfOdontogramasConvenciones : marcacion)
  elem?.closest("svg")?.classList?.toggle("marcacionSeleccionada")
}
const setDientosSanosByTipo = async (tipo: string) => {
  if (isLoadingBtnSanos.value || guardando.value) return
  isLoadingBtnSanos.value = true
  try {
    if (tipo === 'AUSENTE') {
      await setDientesAusentes(odontograma, false, cittId)
    } else {
      await setDientesSanos(tipo, odontograma, false, cittId)
    }
    const store = getStore()
    const xmlResult = await generarSVG(props.odontograma, props.cittId, props.isView, {
      isView: props.isView,
      datos: store,
      comp: props.comp
    })
    xml.value = null
    await nextTick()
    xml.value = xmlResult
  } catch (error) {
    window.notificacion.notificacion('failure', error instanceof Error ? error.message : 'No se pudieron aplicar las marcaciones')
  } finally {
    isLoadingBtnSanos.value = false
  }
}
const guardar = async () => {
  if (guardando.value || isLoadingBtnSanos.value) return
  guardando.value = true
  try {
    const store = getStore()
    await odontologicaService.createOdontograma(props.cittId, props.odontograma.coodId as number, store)
    props.setDatosOdontologia(props.odontograma, { datos: store, comp: props.comp, cittId: props.cittId })
    closeModal('form-odontogramas-' + props.comp?.name)
  } finally {
    guardando.value = false
  }
}
const renderizarOdontograma = async (data: ICitaOdontologicas[] = []) => {
  const xmlResult = await generarSVG(props.odontograma, props.cittId, props.isView, {
    isView: props.isView,
    comp: props.comp,
    data,
    datos: getStore()
  })
  xml.value = null
  await nextTick()
  xml.value = xmlResult
}

watch(
  () => getAusentesAtencion(cittId).map(e => e.ciodDiente).sort().join(','),
  () => {
    if(odontograma.coodNombre == 'Control placa' && !isView && xml.value) renderizarOdontograma()
  }
)

watch(
  () => getDientesPresentesAtencion(cittId),
  () => {
    if (odontograma.coodNombre === 'Control placa' && !isView && props.comp && xml.value) {
      props.setDatosOdontologia(odontograma, { datos: getStore(), comp: props.comp, cittId })
    }
  }
)

onMounted(async () => {
  const { data } = await odontologicaService.listOdontologicas(cittId, odontograma.coodId as number, props.comp ? true : false)
  await renderizarOdontograma(data.body)
})
</script>
<style scoped>
.canvas {
  width: 1200px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
</style>
